<template lang="pug">
app-dialog( v-model="$_show" header="Добавить регион" width="800" )
  v-layout
    v-flex( xs6 )
      expert-region-form( ref="formRegion" :form.sync="form" )
    v-flex.ml-6( xs6 )
      expert-region-organisation-form( :form.sync="form" )
  v-layout
    expert-bank-account-form( ref="formBankAccount" :form.sync="form.bankAccount" )
  .d-flex.flex-row-reverse
    app-button-action( @click="confirmSave()" ) Добавить
</template>

<script>
import { AppDialogToggable } from "@/components"
import ExpertRegionForm from "../forms/ExpertRegionForm.vue";
import ExpertRegionOrganisationForm from "../forms/ExpertRegionOrganisationForm.vue";
import ExpertBankAccountForm from '../forms/ExpertBankAccountForm.vue';
import { ExpertRegion } from '../models/ExpertRegion.model.js'

export default {
  name: "ExpertAddRegionDialog",
  mixins: [AppDialogToggable],

  components: {
    ExpertRegionForm,
    ExpertRegionOrganisationForm,
    ExpertBankAccountForm
  },

  data() {
    return {
      form: new ExpertRegion()
    }
  },

  methods: {
    confirmSave() {
      if (this.$refs.formRegion.$refs.regionForm.validate() && this.$refs.formBankAccount.$refs.bankAccountForm.validate()) {
        this.$emit('save', this.form)
        this.$_show = false
        this.form = new ExpertRegion() 
      }
    }
  }
}
</script>